import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/shipping-insurance.jpg'),
    alt: 'shipping insurance page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'shipping insurance page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Shipping <span>Insurance</span> <span>To Protect Your Shipments</span>',
  description:
    'Unexpected events like loss, damage, or theft during transit can disrupt your plans. ShipAndStorage Shipping Insurance safeguards your shipments, ensuring peace of mind.',
  image: {
    url: '/images/v2/pages/main-pages/shipping-insurance/hero-image.jpg',
    alt: 'snowboard-shipping'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get a Free Quote' }
}

export const helperSectionContent = {
  title: 'What is Shipping Insurance?',

  articles: [
    {
      content: [
        {
          description:
            'Shipping insurance reimburses you for the declared value of a shipment in case of unexpected events like loss, damage, or theft during transit. It’s an affordable solution that provides financial security and confidence when shipping valuable goods.'
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/what-is-shipping-insurance.svg',
        alt: 'Packing Guidelines'
      }
    }
  ]
}

export const whyWeSectionContent = {
  title: 'Shipping Insurance for Protecting Your Items',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Ship with Us' },

  cards: [
    {
      id: 1,
      title: 'Coverage Against Loss',
      description: 'Ensure financial protection for shipments that go missing during transit.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/coverage-against-loss.svg',
        alt: 'Coverage Against Loss service'
      }
    },
    {
      id: 2,
      title: 'Damage Protection',
      description: 'Get reimbursed for damaged goods, ensuring peace of mind for valuable shipments.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/damage-protection.svg',
        alt: 'Damage Protection service'
      }
    },
    {
      id: 3,
      title: 'Theft Coverage',
      description: 'Safeguard your items against theft during transit with comprehensive insurance.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/theft-coverage.svg',
        alt: 'Theft Coverage service'
      }
    },
    {
      id: 4,
      title: 'High-Value Item Security',
      description: 'Insure high-value items like electronics and artwork for secure shipping.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/high-value-item-security.svg',
        alt: 'High-Value Item Security service'
      }
    }
  ]
}

export const protectYourItemsSectionContent = {
  title: 'Protect Your Items with Shipping Insurance',

  articles: [
    {
      content: [
        {
          description:
            'Shipping your items can be unpredictable, but ShipAndStorage’s insurance ensures peace of mind. Whether it’s loss, damage, or theft, our robust coverage guarantees your items are protected from unforeseen issues during transit. Rest assured that your shipments are in safe hands with us.'
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/protect-your-items-with-shipping-insurance.svg',
        alt: 'Protect Your Items with Shipping Insurance'
      }
    }
  ]
}

export const whatDoesShipAndStorageSectionContent = {
  title: 'What Does ShipAndStorage Shipping Insurance Cover?',
  description:
    'Our shipping insurance provides comprehensive protection, ensuring peace of mind when sending valuable items. ',

  cards: [
    {
      id: 1,
      title: 'Lost Shipments',
      description:
        'ShipAndStorage insurance provides reliable coverage for high-value shipments, including electronics, furniture, and artwork.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/lost-shipments.svg',
        alt: 'Lost Shipments service'
      }
    },
    {
      id: 2,
      title: 'Transit Damage',
      description:
        'Shipments can be damaged during transit. Insurance covers repair or replacement costs, ensuring your items arrive in perfect condition.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/transit-damage.svg',
        alt: 'Transit Damage service'
      }
    },
    {
      id: 3,
      title: 'Theft During Shipping',
      description:
        'Theft during transit is rare, but if it happens, our shipping insurance reimburses you for stolen items, so you can resend shipments confidently.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/theft-during-shipping.svg',
        alt: 'Theft During Shipping service'
      }
    },
    {
      id: 4,
      title: 'High-Value Items',
      description:
        'ShipAndStorage insurance provides reliable coverage for high-value shipments, including electronics, furniture, and artwork.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/high-value-items.svg',
        alt: 'High-Value Items service'
      }
    }
  ]
}

export const serviceTipsSectionSectionContent = {
  title: 'Who Needs Shipping Insurance?',
  description: 'Shipping insurance is a must for anyone sending goods that are valuable or difficult to replace. ',

  cards: [
    {
      id: 1,
      title: 'Small Businesses',
      description:
        'For e-commerce businesses and retailers, insurance protects profits by ensuring you don’t bear the cost of replacing lost or damaged goods. ',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/small-businesses.svg',
        alt: 'Small Businesses service'
      }
    },
    {
      id: 2,
      title: 'Individuals',
      description:
        'If you’re sending personal items, gifts, or essential documents, insurance provides financial security and guarantees peace of mind when shipping valuable goods.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/individuals.svg',
        alt: 'Individuals service'
      }
    },
    {
      id: 3,
      title: 'E-commerce Sellers',
      description:
        'Satisfied customers are crucial to online businesses. Shipping insurance lets you replace or refund orders quickly, avoiding disputes and negative reviews.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/e-commerce-sellers.svg',
        alt: 'E-commerce Sellers service'
      }
    },
    {
      id: 4,
      title: 'Frequent Shippers',
      description:
        'Regular shippers, both businesses and individuals, benefit from insurance that protects each shipment and your finances against loss or damage.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/frequent-shippers.svg',
        alt: 'Frequent Shippers service'
      }
    },
    {
      id: 5,
      title: 'International Shippers',
      description:
        'Sending goods across borders involves additional risks, such as customs delays or mishandling. Insurance ensures your shipment is protected.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/international-shippers.svg',
        alt: 'International Shippers service'
      }
    },
    {
      id: 6,
      title: 'Event Organizers',
      description:
        'Insurance protects your investment when shipping equipment, decor, or merchandise for events, ensuring smooth execution.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/event-organizers.svg',
        alt: 'Event Organizers service'
      }
    }
  ]
}

export const whatsNotCoveredSectionContent = {
  title: 'What’s Not Covered?',
  description:
    'While our shipping insurance offers extensive coverage, certain situations are excluded to maintain transparency. ',

  articles: [
    {
      content: [
        {
          points: [
            '<strong>Improper Packaging:</strong> Damage caused by insufficient or unsuitable packaging is not covered. Proper packing ensures your items arrive safely.',
            '<strong>Normal Wear and Tear:</strong> Minor cosmetic damage like surface scratches or normal wear is not included, as it doesn’t affect usability.',
            '<strong>Customer Negligence:</strong> Loss or damage caused by mishandling of goods by the sender, customer, or their agents cannot be reimbursed under insurance.',
            '<strong>Leaks or Defective Items:</strong> If items are internally defective or leak during transit, resulting damage is excluded from the coverage.'
          ]
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/whats-not-covered.jpg',
        alt: 'What’s Not Covered?'
      }
    }
  ]
}

export const forWhoSectionContent = {
  title: 'Why Choose ShipAndStorage?',
  description:
    'ShipAndStorage stands out for our reliable, transparent, and customer-friendly shipping insurance services.',

  cards: [
    {
      id: 1,
      title: 'Comprehensive Coverage',
      description: 'We protect against lost, damaged, or stolen shipments with plans tailored to meet your needs.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/comprehensive-coverage.svg',
        alt: 'Comprehensive Coverage service'
      }
    },
    {
      id: 2,
      title: 'Affordable Rates',
      description:
        'Our insurance plans are budget-friendly, allowing you to safeguard high-value shipments without overspending.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/affordable-rates.svg',
        alt: 'Affordable Rates service'
      }
    },
    {
      id: 3,
      title: 'Quick Claims Process',
      description:
        'File claims easily and receive prompt reimbursements, ensuring seamless resolutions for any shipping issues.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/quick-claims-process.svg',
        alt: 'Quick Claims Process service'
      }
    },
    {
      id: 4,
      title: 'Reliable Support',
      description:
        'Our dedicated customer service team is available to assist you through the claims process and answer all your questions.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/reliable-support.svg',
        alt: 'Reliable Support service'
      }
    },
    {
      id: 5,
      title: 'Global Coverage',
      description:
        'ShipAndStorage provides shipping insurance for all shipments, ensuring consistent protection for your goods.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/global-coverage.svg',
        alt: 'Global Coverage service'
      }
    },
    {
      id: 6,
      title: 'Tailored Policies',
      description:
        'We offer flexible insurance options based on shipment type, value, and destination, so you pay only for the coverage you need.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-insurance/tailored-policies.svg',
        alt: 'Tailored Policies service'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Protect Your Items with Shipping Insurance',
  description:
    'Learn about shipping insurance options to protect your valuable items during transit. Ensure safe delivery with coverage.',
  image: {
    src: '/images/v2/pages/main-pages/shipping-insurance/promotional-banner-image.svg',
    alt: 'Protect Your Items with Shipping Insurance'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Ship Confidently' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'What is the cost of shipping insurance?',
      answer:
        'The cost depends on the shipment value, destination, and item type. ShipAndStorage offers affordable rates.'
    },
    {
      id: 2,
      question: 'How do I file a claim?',
      answer: 'Contact our team with proof of value and damage photos. We’ll guide you through the claims process.'
    },
    {
      id: 3,
      question: 'Can I insure international shipments?',
      answer: 'Yes, we provide coverage for both domestic and international shipments.'
    },
    {
      id: 4,
      question: 'What if my package isn’t delivered but isn’t lost?',
      answer: 'We’ll work with the carrier to locate it. If declared lost, insurance covers the value.'
    },
    {
      id: 5,
      question: 'Is there a maximum insurance limit?',
      answer: 'Yes, limits vary by shipment. Contact us for high-value coverage options.'
    }
  ]
}
